export const ROOT = 'root'
export const CODE = 'code'
export const LISTS = 'lists'
export const ERROR = 'error'

export const routes = [
  {
    name: ROOT,
    path: '/'
  },
  {
    name: CODE,
    path: '/code'
  },
  {
    name: LISTS,
    path: '/lists'
  },
  {
    name: ERROR,
    path: '/error'
  }
]
